export default __webpack_public_path__ + "static/media/checklist.d6e85d44.svg";